import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { LicenseService } from '../../core/services/http-services/license.service';

@Component({
  selector: 'pdf-assigner',
  templateUrl: './pdf-assigner.component.html',
  styleUrls: ['./pdf-assigner.component.scss'],
})
export class PdfAssignerComponent implements OnDestroy {

  public pendingUserAccess: boolean = true;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private readonly licenseService: LicenseService
  ) {
    this.subscriptions.add(
      this.licenseService.isStatusInPending.subscribe((isPending: boolean) => this.pendingUserAccess = isPending)
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
